import type { StateAbbreviation } from '@ria-client/supergraph/marketplace/types';
import { isValidState } from '@ria-client/supergraph/utils/geo-data';

const REGION_CODE_COOKIE_NAME = 'X-Cf-Request-RegionCode';

export function getSafeRegionCodeFromClientCookies(): StateAbbreviation | undefined {
  const regionCode =
    document.cookie
      .split(';')
      .map(cookie => cookie.trim())
      .find(cookie => cookie.startsWith(`${REGION_CODE_COOKIE_NAME}=`))
      ?.slice(REGION_CODE_COOKIE_NAME.length + 1) ?? '';

  return isValidState(regionCode) ? regionCode : undefined;
}
